import {useEffect, useState} from 'react';
import {useParams, Link} from 'react-router-dom';
import {Button, Col, Row, Spin, Typography} from 'antd';
import type {NewPackageById} from '@PikaDoApp/npm-pikado-logic/dist/modules/package/graphql/package.interface';
import {PackagesService} from './PackagesService';
import {resolveI18nObject} from '../../utils';

const packagesService = new PackagesService();

export const PackageDetails = () => {
  const [programPackage, setProgramPackage] = useState<
    NewPackageById | undefined
  >(undefined);
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  let params: {packageId: string} = useParams();

  const {Title, Text} = Typography;

  useEffect(() => {
    packagesService
      .getPackageById(params.packageId)
      .then(resp => {
        console.log('Package details response:', resp);
        setIsLoading(false);
        setProgramPackage(resp);
      })
      .catch(error => {
        console.log('Error fetching package:', error);
        setIsLoading(false);
        setIsError(true);
      });
  }, [params.packageId]);

  return (
    <div style={{padding: 10}}>
      <Title style={{textAlign: 'center'}}>Package </Title>
      <Button size={'large'} style={{float: 'right'}}>
        <Link
          // @ts-ignore
          to={{
            pathname: '/packages/' + programPackage?._id + '/edit',
            state: {package: programPackage},
          }}>
          Edit
        </Link>
      </Button>
      {!isError && !isLoading && (
        <>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Package ID
                </Text>
                <Text>{programPackage?._id}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Package Name
                </Text>
                <Text>
                  {programPackage?.name_i18n?.en ||
                    programPackage?.name_i18n?.ar ||
                    'N/A'}
                </Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Package Description
                </Text>
                <Text>
                  {programPackage?.description_i18n?.en ||
                    programPackage?.description_i18n?.ar ||
                    'N/A'}
                </Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Benefits
                </Text>
                <Text>
                  {programPackage?.benefits_i18n?.en ||
                    programPackage?.benefits_i18n?.ar ||
                    'N/A'}
                </Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Package Duration
                </Text>
                <Text>{programPackage?.packageDuration} months</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Program ID
                </Text>
                <Text>{programPackage?.programId}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Type
                </Text>
                <Text>{programPackage?.type}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Only AI
                </Text>
                <Text>{programPackage?.onlyAI ? 'Yes' : 'No'}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Is Free
                </Text>
                <Text>{programPackage?.isFree ? 'Yes' : 'No'}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Is Active
                </Text>
                <Text>{programPackage?.isActive ? 'Yes' : 'No'}</Text>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Pricing
                </Text>
                {programPackage?.price && (
                  <>
                    <div>
                      <Text strong>US: </Text>
                      <Text>
                        {programPackage.price.US.price}{' '}
                        {programPackage.price.US.currency}
                      </Text>
                    </div>
                    {programPackage.price.AE && (
                      <div>
                        <Text strong>AE: </Text>
                        <Text>
                          {programPackage.price.AE.price}{' '}
                          {programPackage.price.AE.currency}
                        </Text>
                      </div>
                    )}
                    {programPackage.price.EG && (
                      <div>
                        <Text strong>EG: </Text>
                        <Text>
                          {programPackage.price.EG.price}{' '}
                          {programPackage.price.EG.currency}
                        </Text>
                      </div>
                    )}
                    {programPackage.price.SA && (
                      <div>
                        <Text strong>SA: </Text>
                        <Text>
                          {programPackage.price.SA.price}{' '}
                          {programPackage.price.SA.currency}
                        </Text>
                      </div>
                    )}
                    {programPackage.price.QA && (
                      <div>
                        <Text strong>QA: </Text>
                        <Text>
                          {programPackage.price.QA.price}{' '}
                          {programPackage.price.QA.currency}
                        </Text>
                      </div>
                    )}
                    {programPackage.price.KW && (
                      <div>
                        <Text strong>KW: </Text>
                        <Text>
                          {programPackage.price.KW.price}{' '}
                          {programPackage.price.KW.currency}
                        </Text>
                      </div>
                    )}
                    {programPackage.price.TR && (
                      <div>
                        <Text strong>TR: </Text>
                        <Text>
                          {programPackage.price.TR.price}{' '}
                          {programPackage.price.TR.currency}
                        </Text>
                      </div>
                    )}
                  </>
                )}
              </div>
            </Col>
          </Row>
          {programPackage?.productIAP && (
            <Row>
              <Col span={12}>
                <div style={{margin: 20}}>
                  <Text style={{display: 'block'}} strong={true}>
                    Product IAP
                  </Text>
                  <Text>{programPackage.productIAP}</Text>
                </div>
              </Col>
            </Row>
          )}
          <Row>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Created At
                </Text>
                <Text>{programPackage?.createdAt}</Text>
              </div>
            </Col>
            <Col span={12}>
              <div style={{margin: 20}}>
                <Text style={{display: 'block'}} strong={true}>
                  Updated At
                </Text>
                <Text>{programPackage?.updatedAt}</Text>
              </div>
            </Col>
          </Row>
        </>
      )}
      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>Package fetching error ⚠️</Title>}
    </div>
  );
};
